export default "__VITE_ASSET__YSo3MSze__"